<template>
  <span class="copyable-static-value">
    <pc-tooltip value="Click to copy">
      <a href="#" @click.stop.prevent="valueClicked" data-id="518fdc5240a61c028350bb10f2fa30ef">
        <slot></slot>
      </a>
    </pc-tooltip>
    <input
      type="text"
      v-model="valueToCopy"
      v-if="copying"
      data-id="09fbcce90279269ef60b1cbbc0f0fcab"
      style="opacity: 0; width: 10px; height: 1px; position: absolute"
    />
  </span>
</template>

<script>
import $ from "jquery";

export default {
  data: function () {
    return {
      copying: false,
    };
  },
  methods: {
    valueClicked: function () {
      this.copying = true;

      this.$nextTick(() => {
        $(this.$el).children("input").focus();
        $(this.$el).children("input").select();
        document.execCommand("copy");
        this.copying = false;

        this.$snackbar.show("'" + this.valueToCopy + "' copied to clipboard.");
      });
    },
  },

  computed: {
    valueToCopy: function () {
      return this.$slots.default[0].text.trim();
    },
  },

  mounted: function () {},
};
</script>

<style lang="scss">
.copyable-static-value {
  a,
  a:link,
  a:visited {
    text-decoration: none;
    color: inherit;
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: $penChecksGray;
  }

  &.has-error {
    color: $penChecksRed;
  }
}
</style>
